import { useQuery } from "@tanstack/react-query";
import { fetchAccountBalances } from "../services";
import { bigDecimal } from "js-big-decimal";
import { queryKeys } from "../lib/queryKeys";
import { QUERY_TIERS } from "../lib/queryConfig";

export const useAccountBalance = (address: string | null) => {
  return useQuery({
    queryKey: queryKeys.accountBalances.byAddress(address!),
    queryFn: async () => {
      if (!address) throw new Error("No address provided");

      const accountBalances = await fetchAccountBalances({ address });
      const balance = new bigDecimal(0);

      if (accountBalances.balances.length > 0) {
        const nostBalance = accountBalances.balances.find((b) => b.denom === "nost");
        if (nostBalance) {
          balance.setValue(nostBalance.amount);
        }
      }

      return balance;
    },
    enabled: !!address,
    ...QUERY_TIERS.financial,
  });
};
